import ImageSetAnnotationOverlay from "./ImageSetAnnotationOverlay";
import { useStore } from 'react-redux';
import ImagePreview from "./ImagePreview";
import G from './Getters';
export default function MembraneImageLayout({
  structure, 
  toHighlight=[],
  onEvent,
  expandMembrane,
  maxMembraneWidth
}){

  const store = useStore();
  const state = store.getState();


  return (
    <div class="full-width ">

    {structure.map(rows => {
        return (
          <div class="sg-row">
            {rows.map(stain => {

              let hi = toHighlight.includes(stain);

              if( !hi && !expandMembrane ){
                return null;
              }

              let atns = G.getAnnotationsByImageId(state,stain);
              if( !atns ){
                throw Error(`No atns found for stain = ${stain}`);
              }



              let label = atns.find(x => x.ls)?.label;
              if(!label){
                //debugger;
              }

              return (
                <div style={{
                  width:maxMembraneWidth,
                  borderRadius:10,
                }}>
                  {expandMembrane && (<div class="sg-row v-center">
                    
                    <div style={{
                      fontWeight:hi?'bold':'unset',
                      fontSize:"1vw",
                    }}>{label}</div>
                    <div class="flex-expand"/>
                    
                  </div>)}

                  <div class="rel" style={{
                    cursor:'pointer',
                    zIndex:100,
                    margin:1,
                  }}>

                    

                    {false && hi && <div style={{
                      background:'#ccc',
                      border:'3px solid black',
                    }} class="absolute-cover"/>}

                    <ImagePreview onClick={() => {
                      onEvent({
                        type:"selectImage",
                        imageId:stain
                      })
                    }} 
                    imageId={stain}/>

                    <ImageSetAnnotationOverlay {...{
                      imageId:stain,
                    }}/>

                    {toHighlight.length > 0 && <div 
                      style={{
                        opacity:(hi?1:0.5),
                      }}

                      class="absolute-cover">

                      
                    </div>}

                    {toHighlight.length > 0 && !hi && <div style={{
                      background:'white',
                      opacity:0.6
                    }} class="absolute-cover"/>}

                    



                  </div>
                </div>
            )})}
          </div>
        )
      })}
    </div>
  )


}
